import React from "react";
import styles from "./style.scss";

import Select, { OnChangeValue } from "react-select";

interface Option {
  seq: string;
  label: string;
  inneyCode: string;
  value: string;
}

interface Props {
  className?: string;
  optionList: Option[];
  onSelected: (option: Option) => void;
  selectedOption: string;
}

const Search: React.FunctionComponent<Props> = ({
  selectedOption = "",
  optionList,
  onSelected,
  className
}) => {
  const handleChange = (object: OnChangeValue<Option, false>) => {
    if (!object) return;

    const selected = optionList.find(
      row => row.value == (object as Option).value
    );

    if (!selected) return;
    onSelected(selected);
  };

  const value =
    selectedOption === ""
      ? optionList[0]
      : optionList.find(item => item.value === selectedOption);

  return (
    <Select
      className={`${styles.component} ${className}`}
      value={value}
      options={optionList}
      onChange={handleChange}
      isClearable={false}
      classNames={{
        control: () => "Select-value",
        option: () => "Select-option"
      }}
      styles={{
        control: (base: any, state: { menuIsOpen: boolean }) => ({
          ...base,
          borderColor: "#c6e0f0",
          borderRadius: state.menuIsOpen ? "4px 4px 0 0" : 4,
          boxShadow: "none",
          "&:hover": {
            borderColor: "#c6e0f0",
            boxShadow: "0 1px 0 rgba(0, 0, 0, 0.06)"
          }
        }),
        menu: (base: any) => ({
          ...base,
          margin: "0 1px",
          borderRadius: "0 0 4px 4px",
          width: "198px"
        }),
        indicatorSeparator: (base: any) => ({ ...base, display: "none" }),
        option: (base: any, state: { isSelected: boolean }) => ({
          ...base,
          cursor: "pointer",
          backgroundColor: state.isSelected ? "#eff5fe" : "#fff",
          color: "#333",
          "&:hover": {
            backgroundColor: "#eff5fe"
          }
        })
      }}
    />
  );
};

export default Search;
